import { t } from 'i18next';
import * as yup from 'yup';

export const quotePartResetPricingSchema = () =>
  yup
    .object()
    .shape({
      price: yup.boolean().nullable(),
      cost: yup.boolean().nullable(),
    })
    .test({
      name: 'atLeastOneChecked',
      test: function (value) {
        const { price, cost } = value || {};
        if (!price && !cost) {
          return this.createError({
            message: t('messageAtLeastOneChecked'),
            path: 'price',
          });
        }

        return true;
      },
    })
    .test({
      name: 'atLeastOneChecked',
      test: function (value) {
        const { price, cost } = value || {};
        if (!price && !cost) {
          return this.createError({
            path: 'cost',
          });
        }

        return true;
      },
    });
